(function () {
  var COOKIE_NAME = 'gfy_popup_ab';
  var TEST_NAME = 'popup_copy_test';
  var COOKIE_DAYS = 30;

  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : null;
  }

  function setCookie(name, value, days) {
    var expires = new Date(Date.now() + days * 864e5).toUTCString();
    document.cookie = name + '=' + encodeURIComponent(value) + '; expires=' + expires + '; path=/';
  }

  var variant = getCookie(COOKIE_NAME);
  if (variant !== 'A' && variant !== 'B') {
    variant = Math.random() < 0.5 ? 'A' : 'B';
    setCookie(COOKIE_NAME, variant, COOKIE_DAYS);
  }

  window.dataLayer = window.dataLayer || [];

  // Variant A keeps whatever copy is set in the theme editor (current live copy).
  // Variant B is the alternate angle for this test, applied client-side.
  var VARIANT_B_COPY = {
    subheading: 'Don\u2019t Miss Out',
    text: '<strong>Unlock 10% Off</strong> \u2014 Just For Joining'
  };

  function fireEvent(eventName) {
    window.dataLayer.push({
      event: eventName,
      ab_test: TEST_NAME,
      variant: variant
    });
  }

  function init() {
    var root = document.querySelector('promo-popup .popup__content');
    if (!root) return;

    if (variant === 'B') {
      var sub = root.querySelector('.popup__subheading');
      var txt = root.querySelector('.popup__text');
      if (sub) sub.textContent = VARIANT_B_COPY.subheading;
      if (txt) txt.innerHTML = VARIANT_B_COPY.text;
    }

    fireEvent('popup_variant_shown');

    var form = root.querySelector('form.popup__newsletter');
    if (!form) return;

    var fired = false;
    var observer = new MutationObserver(function () {
      if (fired) return;
      var success = form.parentNode && form.parentNode.querySelector('[id^="Newsletter-success"]');
      if (success) {
        fired = true;
        fireEvent('popup_signup_conversion');
        observer.disconnect();
      }
    });
    observer.observe(form.parentNode || root, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();